// this file was auto-generated by rake i18n:generate_js.
// you probably shouldn't edit it directly
import mergeI18nTranslations from 'mergeI18nTranslations';

mergeI18nTranslations({"en-AU":{"CollectionView":{"no_items":"No items."}},"en-CA":{"CollectionView":{"no_items":"No items."}},"en-GB":{"CollectionView":{"no_items":"No items."}},"is":{"CollectionView":{"no_items":"Engin atriði."}},"mi":{"CollectionView":{"no_items":"Kāore he tūemi."}},"ru":{"CollectionView":{"no_items":"Элементы отсутствуют."}}});
